export default "__VITE_ASSET__DwgQn671__"